import { initializeDatadog } from "./datadog";
import { armSoleraHandoffClock } from "./rumMonitoring";
import { initializeSentry } from "./sentry";

export default function bootstrap() {
  // Sentry first so Datadog init errors are reported.
  initializeSentry();
  initializeDatadog();
  armSoleraHandoffClock();
}
